import React, { useEffect } from 'react';
import { Oval } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { allUserPayments } from '../../actions/payment.action';
import style from './Payments.module.css';

const Payments = () => {
  const dispatch = useDispatch();
  const curUser = JSON.parse(localStorage.getItem('curUser'));

  const { payment, loading, success } = useSelector(
    (state) => state.userAllPaymentByIdReducer
  );

  useEffect(() => {
    dispatch(allUserPayments(curUser.user._id));
  }, [dispatch]);
  return (
    <>
      <h1 style={{ color: 'rgb(206, 144, 206)' }}>Payments</h1>
      <div className={style.LoginHistory}>
        {!loading && success ? (
          payment.length !== 0 ? (
            <div>
              <div className={style.TableHead}>
                <div>Date</div>
                <div>Payment ID</div>
                <div>Report ID</div>
                <div>Amount</div>
                <div>Status</div>
              </div>
              <div>
                {payment.map((p) => {
                  let date = new Date(p.date).toString();
                  const result = date.split(' ');
                  const newDate = `${result[2]}/${result[1]}/${result[3]}`;
                  const newTime = result[4];
                  return (
                    <div className={style.TableData} key={p._id}>
                      <div className={style.TimeDate}>
                        <div className={style.Date}>{newDate}</div>
                        <div className={style.Time}>{`Time - ${newTime}`}</div>
                      </div>
                      <div>{p._id}</div>
                      <div>{p.report}</div>
                      <div>{p.amount}</div>
                      <div>{p.status}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className={style.Center} style={{ fontWeight: '500' }}>
              No payment found!
            </div>
          )
        ) : (
          <div className={style.Center}>
            <Oval
              ariaLabel='loading-indicator'
              height={80}
              width={80}
              strokeWidth={5}
              color='white'
              secondaryColor='purple'
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Payments;
